import { createI18n } from 'vue-i18n';
import fr from './locales/fr-FR.json';

export const i18n = createI18n({
  legacy: false,
  locale: 'fr-FR',
  fallbackLocale: 'fr-FR',
  messages: {
    'fr-FR': fr,
  },
});
